import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  textField: {
    margin: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  table: {
    minWidth: 850,
  },
  tableContainer: {
    minWidth: 850,
    marginTop: 50,
  },
}));

export default useStyles;
